import api from "./api";
import type {
  SavedLibraryView,
  SavedLibraryViewCreate,
  SavedLibraryViewUpdate,
} from "../types";
import { conditionalHeaders } from "./concurrency";

export const libraryViewService = {
  async list(signal?: AbortSignal): Promise<SavedLibraryView[]> {
    return (await api.get<SavedLibraryView[]>("/library/views", { signal })).data;
  },
  async create(payload: SavedLibraryViewCreate): Promise<SavedLibraryView> {
    return (await api.post<SavedLibraryView>("/library/views", payload)).data;
  },
  async update(
    id: number,
    payload: SavedLibraryViewUpdate,
    updatedAt?: string
  ): Promise<SavedLibraryView> {
    return (
      await api.patch<SavedLibraryView>(`/library/views/${id}`, payload, {
        headers: conditionalHeaders(updatedAt),
      })
    ).data;
  },
  async remove(id: number, updatedAt?: string): Promise<void> {
    await api.delete(`/library/views/${id}`, {
      headers: conditionalHeaders(updatedAt),
    });
  },
};
